import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionEditStore from '../../../Store';
import LearningDesignAccordion from './LearningDesignAccordion';
import { DraggableProvided } from '@hello-pangea/dnd';
import { LearningDesignSection } from '../../../../Types';

interface Props {
  store: LearningCollectionEditStore;
  section: LearningDesignSection;
  provided: DraggableProvided;
}

const LearningDesign: React.FC<Props> = ({ store, section, provided }) => {
  switch (section.resource.payload.learningDesignState) {
    case 'curated':
      return (
        <LearningDesignAccordion
          section={section}
          store={store}
          disabled={true}
          provided={provided}
        />
      );
    case 'curated-custom':
    case 'custom':
    case 'blank':
    case 'build-your-own':
    case 'browse-all':
      return (
        <LearningDesignAccordion
          section={section}
          store={store}
          disabled={false}
          provided={provided}
        />
      );
    case 'empty':
      return <></>;
  }
};

export default observer(LearningDesign);
